import React from 'react';
import { useSummaryStore } from '@src/stores/summaryStore';
import { RETURN_METHOD } from '@src/constants/general';
import { getFeatureSwitchStatic } from '@src/utils/general';
import { SorisNextSteps } from './SorisNextSteps';
import { LORPNextSteps } from './LORPNextSteps';
import { UPSNextSteps } from './UPSNextSteps';
export var NextSteps = function () {
    var returnMethod = useSummaryStore(function (state) { return state.returnMethod; });
    if (getFeatureSwitchStatic('allowSORIS') &&
        returnMethod === RETURN_METHOD.IN_STORE)
        return React.createElement(SorisNextSteps, null);
    if (getFeatureSwitchStatic('isLORPEnabled') &&
        returnMethod === RETURN_METHOD.LORP)
        return React.createElement(LORPNextSteps, null);
    return React.createElement(UPSNextSteps, null);
};
